export const BOND_HEADER_ACTIONS = {
    BOND_HEADER_REQUEST: "BOND_HEADER_REQUEST",
    BOND_HEADER_RESPONSE: "BOND_HEADER_RESPONSE",
    BOND_HEADER_ERROR: "BOND_HEADER_ERROR",
  };
  export const BOND_ANALYTICS_ACTIONS = {
    BOND_ANALYTICS_REQUEST: "BOND_ANALYTICS_REQUEST",
    BOND_ANALYTICS_RESPONSE: "BOND_ANALYTICS_RESPONSE",
    BOND_ANALYTICS_ERROR: "BOND_ANALYTICS_ERROR",
  };
  
  export const BOND_PRICE_ACTIONS = {
    GET_BOND_PRICE_CHARTS_RESPONSE: 'GET_BOND_PRICE_CHARTS_RESPONSE',
    GET_BOND_PRICE_CHARTS_REQUEST: 'GET_BOND_PRICE_CHARTS_REQUEST',
    GET_BOND_PRICE_CHARTS_ERROR: 'GET_BOND_PRICE_CHARTS_ERROR',
  };
  
  export const BOND_DETAIL_ACTIONS = {
    BOND_DETAIL_REQUEST: "BOND_DETAIL_REQUEST",
    BOND_DETAIL_RESPONSE: "BOND_DETAIL_RESPONSE",
    BOND_DETAIL_ERROR: "BOND_DETAIL_ERROR",
  };
  export const BOND_DETAIL_TOKEN_ACTIONS = {
    BOND_DETAIL_TOKEN_REQUEST: "BOND_DETAIL_TOKEN_REQUEST",
    BOND_DETAIL_TOKEN_RESPONSE: "BOND_DETAIL_TOKEN_RESPONSE",
    BOND_DETAIL_TOKEN_ERROR: "BOND_DETAIL_TOKEN_ERROR",
  };
  export const SAME_ISSUER_BONDS_ACTIONS = {
    SAME_ISSUER_BONDS_REQUEST: "SAME_ISSUER_BONDS_REQUEST",
    SAME_ISSUER_BONDS_RESPONSE: "SAME_ISSUER_BONDS_RESPONSE",
    SAME_ISSUER_BONDS_ERROR: "SAME_ISSUER_BONDS_ERROR",
  };
  
  